import { Action, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";

export enum DISPLAY_OPTIONS {
  MONEY = "R$",
  PERCENTAGE = "%"
}

// Define a TS type for the data we'll be using
interface valueDisplayState {
  displayOption: DISPLAY_OPTIONS,
  displayTitle: string
}

// Create an initial state value for the reducer, with that type
const initialState: valueDisplayState = {
  displayOption: DISPLAY_OPTIONS.MONEY,
  displayTitle: DISPLAY_OPTIONS.MONEY.toString()
}

// Create the slice and pass in the initial state
const valueDisplaySlice = createSlice({
  name: 'valueDisplay',
  initialState,
  reducers: {
    changeToMoney(state, action: Action) {
      state.displayOption = DISPLAY_OPTIONS.MONEY;
      state.displayTitle = DISPLAY_OPTIONS.PERCENTAGE.toString();
    },
    changeToPercentage(state, action: Action) {
      state.displayOption = DISPLAY_OPTIONS.PERCENTAGE;
      state.displayTitle = DISPLAY_OPTIONS.PERCENTAGE.toString();
    }
  }
})

// Export the auto-generated action creator with the same name
export const { changeToMoney, changeToPercentage } = valueDisplaySlice.actions;

// Export the generated reducer function
export default valueDisplaySlice.reducer;
export const selectValueDisplay = (state: RootState) => state.valueDisplay;